import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "dropzone"]
  static values = { url: String, itemId: Number }

  select() {
    this.inputTarget.click()
  }

  // クロッパーなしの直接アップロード（フォールバック）
  upload() {
    const file = this.inputTarget.files[0]
    if (!file) return
    this._uploadFile(file)
  }

  dragOver(e) {
    e.preventDefault()
    this.dropzoneTarget.classList.add("border-brand-500")
  }

  dragLeave(e) {
    e.preventDefault()
    this.dropzoneTarget.classList.remove("border-brand-500")
  }

  drop(e) {
    e.preventDefault()
    this.dropzoneTarget.classList.remove("border-brand-500")
    const file = e.dataTransfer.files[0]
    if (!file) return

    // ファイルをfile inputにセットしてcropperに渡す
    const dt = new DataTransfer()
    dt.items.add(file)
    this.inputTarget.files = dt.files
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  // cropper:confirmed イベント → クロップ後にアップロード
  uploadCropped(event) {
    const { cropData, previewUrl } = event.detail
    const file = this.inputTarget.files[0]
    if (!file) return

    // クロップ済みプレビューをドロップゾーンに表示
    if (previewUrl) {
      this.previewTarget.innerHTML = `<img src="${previewUrl}" class="w-full h-full object-cover rounded-lg">`
    }

    this._uploadFile(file, cropData)
  }

  _uploadFile(file, cropData = null) {
    // プレビューがまだなら元画像で表示
    if (!cropData) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.previewTarget.innerHTML = `<img src="${e.target.result}" class="w-full h-full object-cover rounded-lg">`
      }
      reader.readAsDataURL(file)
    }

    const body = new FormData()
    body.append("item_id", this.itemIdValue)
    body.append("photo", file)
    if (cropData) body.append("crop_data", cropData)

    fetch(this.urlValue, {
      method: "PATCH",
      headers: { "X-CSRF-Token": document.querySelector("[name='csrf-token']").content },
      body
    })
  }
}
